import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63e0b9d3")

_pushScopeId("data-v-63e0b9d3")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "search-filter-container" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  id: "mapContainer",
  style: {"width":"100%","height":"100%"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Loading = _resolveComponent("Loading")

  return (_openBlock(), _createBlock("div", {
    style: [{"position":"relative"}, _ctx.fullHeight]
  }, [
    _createVNode(_component_Loading, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
    _hoisted_1,
    _hoisted_2
  ], 4))
})